import Component from 'vue-class-component';
import Vue from 'vue';
import { Getter, Action } from 'vuex-class';
import { CONFIGURATOR_UPDATE_ITEM, CONFIGURATOR_PRODUCT } from '@/apps/configurator/store/types';
import { LazyMenuItems } from '../constants';

/**
 * Screen to provide lazy menu selection
 */
@Component
export default class LazyMenuMixin extends Vue {
  @Getter itemByKey;
  @Getter lazyMenu;
  @Action(CONFIGURATOR_PRODUCT) setCurrentProduct;
  @Action(CONFIGURATOR_UPDATE_ITEM) addItem;

  /**
   * List of lazy menu products
   */
  get products() {
    return this.lazyMenu;
  }

  get baseProductKey() {
    return this.lazyProduct.productKey;
  }

  get lazyProduct() {
    const lazyProductId = 28;

    return LazyMenuItems[lazyProductId];
  }

  /**
   * Open configurator for passed product key
   * @returns {Promise<void>}
   */
  async openConfigurator(product) {
    const lazyProduct = {
      ...this.lazyProduct,
      title:          product.title,
      configurations: product.items,
    };

    await this.setCurrentProduct({ productKey: this.baseProductKey });

    lazyProduct.configurations.forEach((item) => {
      this.addItem(item);
    });

    this.$router.push({
      name:   'configurator',
      params: {
        id:                 this.baseProductKey,
        currentCategoryKey: lazyProduct.destCategoryKey,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/apps/menu/mixins/lazy-menu-mixin.js